// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { IconMemo, IconProps } from "@insite/mobius/Icon";
import File from "@insite/mobius/Icons/File";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import translate from "@insite/client-framework/Translate";
import { linkActionStyles } from "@store/Themes/common/mixins/link";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
/* Starter Custom Code - End */

/* Store Custom Code - Start */
import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import { DocumentModel } from "@insite/client-framework/Types/ApiModels";
import { getArtSelectionDocuments } from "@store/Framework/Common/Utilities/ProductArtSelectionUtil";
/* Store Custom Code - End */

type OwnProps = WidgetProps & HasProductContext; // Store Custom Code

export interface ProductDetailsDocumentsStyles {
    wrapper?: InjectableCss;
    container?: GridContainerProps;
    documentGridItem?: GridItemProps;
    documentLink?: LinkPresentationProps;
    documentIcon?: IconProps;
    documentNameText?: TypographyPresentationProps;
    // Starter Custom Code
    noResult?: TypographyPresentationProps;
    list?: TypographyPresentationProps;
    listItem?: TypographyPresentationProps;
}

export const documentsStyles: ProductDetailsDocumentsStyles = {
    documentIcon: {
        src: File,
        color: "primary",
        size: 24,
        css: css`
            align-self: flex-start;
            margin-right: ${pxToRem(8)};
        `,
    },
    documentLink: {
        typographyProps: {
            css: css`
                display: flex;
                align-items: center;
            `,
        },
        css: css`
            ${x => linkActionStyles(x.theme.design.typography.size.small)}
        `,
    },
    noResult: {
        forwardAs: "p",
    },
    listItem: {
        css: css`
            ${spacingStyles(null, pxToRem(12))}
            display: flex;
        `,
    },
};

const styles = documentsStyles;

const ProductDetailsDocuments: React.FC<OwnProps> = ({ productContext /* Store Custom Code */ }) => {
    /* Store Custom Code - Start */
    const { product } = productContext;
    const documents = productContext.selectedArtId
        ? (getArtSelectionDocuments(product, productContext.selectedArtId) as DocumentModel[])
        : product.documents;
    /* Store Custom Code - End */
    /* Starter Custom Code - Start */
    if (!documents || documents.length === 0) {
        return (
            <StyledWrapper {...styles.wrapper}>
                <Typography {...styles.noResult}>{translate("There are no documents available.")}</Typography>
            </StyledWrapper>
        );
    }
    /* Starter Custom Code - End */

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography as="ul" {...styles.list /* Starter Custom Code */}>
                {documents.map(document => (
                    <Typography as="li" key={document.id.toString()} {...styles.listItem /* Starter Custom Code */}>
                        <Link
                            href={document.filePath}
                            target="_new"
                            {...styles.documentLink}
                            data-test-selector={`productDetails_${document.id}`}
                        >
                            <IconMemo {...styles.documentIcon} />
                            <Typography {...styles.documentNameText}>{document.name}</Typography>
                        </Link>
                    </Typography>
                ))}
            </Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: withProductContext(ProductDetailsDocuments), // Store Custom Code
    definition: {
        displayName: "Documents",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
